export default "__VITE_ASSET__ab572ac7__"